const period = {
timestamp: null,
validTime: null,
dateTimeISO: null,
maxTempC: null,
maxTempF: null,
minTempC: null,
minTempF: null,
avgTempC: null,
avgTempF: null,
tempC: null,
tempF: null,
pop: null,
precipMM: null,
precipIN: null,
iceaccum: null,
maxHumidity: null,
minHumidity: null,
humidity: null,
uvi: null,
pressureMB: null,
pressureIN: null,
sky: null,
snowCM: null,
snowIN: null,
feelslikeC: null,
feelslikeF: null,
minFeelslikeC: null,
minFeelslikeF: null,
maxFeelslikeC: null,
maxFeelslikeF: null,
avgFeelslikeC: null,
avgFeelslikeF: null,
dewpointC: null,
dewpointF: null,
maxDewpointC: null,
maxDewpointF: null,
minDewpointC: null,
minDewpointF: null,
avgDewpointC: null,
avgDewpointF: null,
windDirDEG: null,
windDir: null,
windDirMaxDEG: null,
windDirMax: null,
windDirMinDEG: null,
windDirMin: null,
windGustKTS: null,
windGustKPH: null,
windGustMPH: null,
windSpeedKTS: null,
windSpeedKPH: null,
windSpeedMPH: null,
windSpeedMaxKTS: null,
windSpeedMaxKPH: null,
windSpeedMaxMPH: null,
windSpeedMinKTS: null,
windSpeedMinKPH: null,
windSpeedMinMPH: null,
windDir80mDEG: null,
windDir80m: null,
windDirMax80mDEG: null,
windDirMax80m: null,
windDirMin80mDEG: null,
windDirMin80m: null,
windGust80mKTS: null,
windGust80mKPH: null,
windGust80mMPH: null,
windSpeed80mKTS: null,
windSpeed80mKPH: null,
windSpeed80mMPH: null,
windSpeedMax80mKTS: null,
windSpeedMax80mKPH: null,
windSpeedMax80mMPH: null,
windSpeedMin80mKTS: null,
windSpeedMin80mKPH: null,
windSpeedMin80mMPH: null,
weather: null,
weatherCoded: [ ],
weatherPrimary: null,
weatherPrimaryCoded: "::FW",
cloudsCoded: "FW",
icon: "msunny.png",
isDay: true
}

export const Tempdata = {
  success: true,
  error: null,
  response: [
    {
      loc: {
        long: 0,
        lat: 0
      },
    interval: "daynight",
    periods: [ period, period, period, period, period, period, period, period, period ]
    }
  ]
}


export const Temptidedata = {
  success: true,
  error: null,
  response: [
    {
      id: "8517276",
      loc: {
        long: 0,
        lat: 0
      },
    place: {
        name: "-",
        state: "ny",
        country: "us"
      },
    periods: [
      {
        timestamp: null,
        dateTimeISO: "2017-11-26T00:00:00-05:00",
        type: "",
        heightFT: 0,
        heightM: 0
      },
      {
        timestamp: null,
        dateTimeISO: "2017-11-26T00:00:00-05:00",
        type: "",
        heightFT: 0,
        heightM: 0
      },
      {
        timestamp: null,
        dateTimeISO: "2017-11-26T00:00:00-05:00",
        type: "",
        heightFT: 0,
        heightM: 0
      },
      {
      timestamp: null,
      dateTimeISO: "2017-11-26T00:00:00-05:00",
      type: "",
      heightFT: 0,
      heightM: 0
      },
      {
      timestamp: null,
      dateTimeISO: "2017-11-27T00:00:00-05:00",
      type: "",
      heightFT: 0,
      heightM: 0
      },
      {
      timestamp: null,
      dateTimeISO: "2017-11-27T00:00:00-05:00",
      type: "",
      heightFT: 0,
      heightM: 0
      },
      {
      timestamp: null,
      dateTimeISO: "2017-11-27T00:00:00-05:00",
      type: "",
      heightFT: 0,
      heightM: 0
      },
      {
      timestamp: null,
      dateTimeISO: "2017-11-27T00:00:00-05:00",
      type: "",
      heightFT: 0,
      heightM: 0
      },
      {
      timestamp: null,
      dateTimeISO: "2017-11-28T00:00:00-05:00",
      type: "",
      heightFT: 0,
      heightM: 0
      },
      {
      timestamp: null,
      dateTimeISO: "2017-11-28T00:00:00-05:00",
      type: "",
      heightFT: 0,
      heightM: 0
      },
      {
      timestamp: null,
      dateTimeISO: "2017-11-28T00:00:00-05:00",
      type: "",
      heightFT: 0,
      heightM: 0
      },
      {
      timestamp: null,
      dateTimeISO: "2017-11-28T00:00:00-05:00",
      type: "",
      heightFT: 0,
      heightM: 0
      },
      {
      timestamp: null,
      dateTimeISO: "2017-11-29T00:00:00-05:00",
      type: "",
      heightFT: 0,
      heightM: 0
      },
      {
      timestamp: null,
      dateTimeISO: "2017-11-29T00:00:00-05:00",
      type: "",
      heightFT: 0,
      heightM: 0
      },
      {
      timestamp: null,
      dateTimeISO: "2017-11-29T00:00:00-05:00",
      type: "",
      heightFT: 0,
      heightM: 0
      },
      {
      timestamp: null,
      dateTimeISO: "2017-11-29T00:00:00-05:00",
      type: "",
      heightFT: 0,
      heightM: 0
      },
      {
      timestamp: null,
      dateTimeISO: "2017-11-30T00:00:00-05:00",
      type: "",
      heightFT: 0,
      heightM: 0
      },
      {
      timestamp: null,
      dateTimeISO: "2017-11-30T00:00:00-05:00",
      type: "",
      heightFT: 0,
      heightM: 0
      },
      {
      timestamp: null,
      dateTimeISO: "2017-11-30T00:00:00-05:00",
      type: "",
      heightFT: 0,
      heightM: 0
      },
      {
      timestamp: null,
      dateTimeISO: "2017-11-30T00:00:00-05:00",
      type: "",
      heightFT: 0,
      heightM: 0
      },
      {
      timestamp: null,
      dateTimeISO: "2017-12-01T00:00:00-05:00",
      type: "",
      heightFT: 0,
      heightM: 0
      },
      {
      timestamp: null,
      dateTimeISO: "2017-12-01T00:00:00-05:00",
      type: "",
      heightFT: 0,
      heightM: 0
      },
      {
      timestamp: null,
      dateTimeISO: "2017-12-01T00:00:00-05:00",
      type: "",
      heightFT: 0,
      heightM: 0
      },
      {
      timestamp: null,
      dateTimeISO: "2017-12-01T00:00:00-05:00",
      type: "",
      heightFT: 0,
      heightM: 0
      },
      {
      timestamp: null,
      dateTimeISO: "2017-12-02T00:00:00-05:00",
      type: "",
      heightFT: 0,
      heightM: 0
      },
      {
      timestamp: null,
      dateTimeISO: "2017-12-02T00:00:00-05:00",
      type: "",
      heightFT: 0,
      heightM: 0
      },
      {
      timestamp: null,
      dateTimeISO: "2017-12-02T00:00:00-05:00",
      type: "",
      heightFT: 0,
      heightM: 0
      },
      {
      timestamp: null,
      dateTimeISO: "2017-12-02T00:00:00-05:00",
      type: "",
      heightFT: 0,
      heightM: 0
      }
    ],
    profile: {
      tz: "America/New_York"
    },
    relativeTo: {
      lat: 0,
      long: 0,
      bearing: 0,
      bearingENG: null,
      distanceKM: 0,
      distanceMI: 0
    }
  }]
}
